export const c_scroll_outer_wrapper_MinHeight = {
  "name": "--pf-c-scroll-outer-wrapper--MinHeight",
  "value": "25rem",
  "var": "var(--pf-c-scroll-outer-wrapper--MinHeight)"
};
export default c_scroll_outer_wrapper_MinHeight;